import React, { Component } from 'react';
import { Link } from 'react-router';
import { siteOfOriginHelper } from '../../../../../../client/helpers/genericHelpers';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBriefcase, faFileContract, faHeart, faThumbsUp } from '@fortawesome/free-solid-svg-icons'

library.add(faBriefcase)
library.add(faFileContract)
library.add(faHeart)
library.add(faThumbsUp)

class JobsLayout extends Component {

    componentWillMount() {
        this.mq = window.matchMedia('(max-width: 840px)');
        this.mq.addListener(this.handleResize);
        this.setState({ isMobile: this.mq.matches });
    }

    componentWillUnmount() {
        this.mq.removeListener(this.handleResize);
    }

    handleResize = mq => {
        this.setState({ isMobile: mq.matches });
    };

    render() {

        const { children } = this.props;
        const siteOfOrigin = siteOfOriginHelper();
        let fav = siteOfOrigin !== 'us' ? 'Favourite' : 'Favorite'

        return (
            <React.Fragment>
                <aside className="scrollto-nav" >
                    <div className="jobs-nav">
                        <Link className={this.state.isActive === 'favourite-jobs' ? "jobs-nav__link active" : "jobs-nav__link"}
                            to={`/my-jobs-section/favourite-jobs`}
                            onClick={() => { this.setState({ isActive: 'favourite-jobs' }) }} >
                            <span className="link__label"><FontAwesomeIcon icon="thumbs-up" />  {!this.state.isMobile && `${fav} Jobs`}</span>
                        </Link>
                        <Link className={this.state.isActive === 'saved-searches' ? "jobs-nav__link active" : "jobs-nav__link"}
                            to={`/my-jobs-section/saved-searches`}
                            onClick={() => { this.setState({ isActive: 'saved-searches' }) }}>
                            <span className="link__label"><FontAwesomeIcon icon="heart" />  {!this.state.isMobile && 'Saved Searches'}</span>
                        </Link>
                        <Link className={this.state.isActive === 'my-applications' ? "jobs-nav__link active" : "jobs-nav__link"}
                            to={`/my-jobs-section/my-applications`}
                            onClick={() => { this.setState({ isActive: 'my-applications' }) }}>
                            <span className="link__label"><FontAwesomeIcon icon="file-contract" />  {!this.state.isMobile && 'My Applications'}</span>
                        </Link>
                    </div>
                </aside>
                <article className="jobs-body">
                    <main className="jobs-body__main">
                        <div className="container">
                            <div className="row">
                                <div className='col-xs-12 col-md-offset-1 col-md-9'>
                                    {children}
                                </div>
                            </div>
                        </div>
                    </main>
                </article>
            </React.Fragment>
        )
    }
}

export default JobsLayout;



// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/JobsLayout.js